import { useState } from "react"
import Button from "../../../../UiComponents/Button"
import Modal from "../../../../UiComponents/Modal";
import ProcessorSetup from "../ProcessorSetup";

const ProcessorScanButton = props => {
    const [showModal, setShowModal] = useState(false);

    const submitHandler = async (object, submitProps) => {
        await props.onSubmit(object, submitProps);
        setShowModal(false);
    }

    return <>
        <Button
            small
            primary = {props.primary}
            secondary = {props.secondary}
            tertiary = {props.tertiary}
            onClick={() => setShowModal(true)}>
            Scan for Processors
        </Button>

        <Modal show={showModal} close={() => setShowModal(false)}>
            <ProcessorSetup 
                {...props}
                onSubmit={submitHandler}
                cancel={() => setShowModal(false)}
                fixedSetupState={'SCAN'}
            />
        </Modal>
    </>
}

export default ProcessorScanButton;